import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import {
  useInrAdminGetQuery,
  useInrDepositMutation,
} from "../../redux/TransactionApi";
import { QRCode } from "react-qrcode-logo";
import { toast } from "react-toastify";

function INRDepositModel({ open, onClose }) {
  const [bankDetails, setBankDetails] = useState({});
  const [upiDetails, setUpiDetails] = useState({});
  const { data: adminData } = useInrAdminGetQuery({ skip: !open });
  const [inrDeposit] = useInrDepositMutation();
  const [btnDisabled, setBtnDisabled] = useState(false);

  // form states
  const [form, setForm] = useState({
    amount: "",
    utr: "",
    payment_screenshot: null,
    admin_account_id: 2, // default bank selected
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (adminData) {
      // setUpiDetails(adminData?.data[0]);
      setBankDetails(adminData?.data[0]);
    }
  }, [adminData]);

const handleChange = (e) => {
  const { name, value, files } = e.target;
  let fieldError = "";

  if (name === "payment_screenshot") {
    const file = files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        fieldError = "File size must not exceed 2 MB";
      } else {
        setForm((prev) => ({ ...prev, payment_screenshot: file }));
      }
    }
  } else {
    setForm((prev) => ({
      ...prev,
      [name]: name === "admin_account_id" ? Number(value) : value, // 🔑 ensures number for radio
    }));

    // validations
    if (name === "amount") {
      if (!value) {
        fieldError = "This field is required";
      } else if (!/^\d{1,7}(\.\d{1,2})?$/.test(value)) {
        fieldError = "Amount must be up to 7 digits and max 2 decimals allowed";
      }
    }

    if (name === "utr") {
      if (!value) {
        fieldError = "This field is required";
      } else if (!/^[A-Za-z0-9]{10,25}$/.test(value)) {
        fieldError =
          "Invalid UTR format. Please enter a valid 10–25 character UTR.";
      }
    }

    if (name === "admin_account_id") {
      if (!value) {
        fieldError = "This field is required";
      }
    }
  }

  setErrors((prev) => ({ ...prev, [name]: fieldError }));
};


  const validate = () => {
    const tempErrors = {};
    let ok = true;
    // amount
    if (!form.amount) {
      tempErrors.amount = "This field is required";
      ok = false;
    } else if (!/^\d{1,7}(\.\d{1,2})?$/.test(form.amount)) {
      tempErrors.amount =
        "Amount must be up to 7 digits and max 2 decimals allowed";
      ok = false;
    }
    // utr
    if (!form.utr) {
      tempErrors.utr = "This field is required";
      ok = false;
    } else if (!/^[A-Za-z0-9]{10,25}$/.test(form.utr)) {
      tempErrors.utr =
        "Invalid UTR format. Please enter a valid 10–25 character UTR.";
      ok = false;
    }
    // payment_screenshot
    if (!form.payment_screenshot) {
      tempErrors.payment_screenshot = "This field is required";
      ok = false;
    } else {
      // double-check file constraints (defensive)
      const f = form.payment_screenshot;
      const allowed = ["image/jpeg", "image/jpg", "image/png"];
      if (!allowed.includes(f.type)) {
        tempErrors.payment_screenshot = "Only JPEG/JPG/PNG files allowed";
        ok = false;
      } else if (f.size > 2 * 1024 * 1024) {
        tempErrors.payment_screenshot = "File size must not exceed 2 MB";
        ok = false;
      }
    }
    // admin_account_id
    if (!form.admin_account_id) {
      tempErrors.admin_account_id = "This field is required";
      ok = false;
    }
    setErrors(tempErrors);
    return ok;
  };

  const handleDeposit = async () => {
    if (!validate()) {
      return;
    }
    try {
      setBtnDisabled(true);
      setTimeout(() => setBtnDisabled(false), 3000);
      const formData = new FormData();
      formData.append("admin_account_id", form.admin_account_id);
      formData.append("amount", form.amount);
      formData.append("utr", form.utr);
      formData.append("payment_screenshot", form.payment_screenshot);

      const { error, data } = await inrDeposit(formData);

      if (error) {
        toast.error(error?.data?.message || "Deposit failed");
      } else {
        toast.success("Deposit request submitted");
        onClose();
        setForm({
          amount: "",
          utr: "",
          payment_screenshot: null,
          admin_account_id: 2, // default back to bank
        });
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  return (
    <Modal show={open} onHide={onClose} className="account-popup-outer">
      <Modal.Header closeButton>
        <Modal.Title>Deposit INR</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Amount input */}
        <div className="form-group">
          <label>I want to deposit</label>
          <input
            type="number"
            className="form-control"
            placeholder="Enter Amount"
            name="amount"
            value={form.amount}
            onChange={handleChange}
          />
          {errors.amount && (
            <span style={{ color: "red" }}>{errors.amount}</span>
          )}
        </div>

        {/* Quick buttons */}
        <div className="form-group">
          {/* <div className="choose-amount d-flex justify-content-around">
            <button
              className="btn btn_man fs14 m0a"
              onClick={() => setForm((p) => ({ ...p, amount: "1000" }))}
            >
              + 1000 INR
            </button>
            <button
              className="btn btn_man fs14 m0a"
              onClick={() => setForm((p) => ({ ...p, amount: "5000" }))}
            >
              + 5000 INR
            </button>
            <button
              className="btn btn_man fs14 m0a"
              onClick={() => setForm((p) => ({ ...p, amount: "10000" }))}
            >
              + 10000 INR
            </button>
          </div> */}
        </div>

        {/* Upload image */}
        <div className="form-group">
          <label>Upload Image:</label>
          <div id="file-upload-form" className="uploader mt-3">
            <input
              type="file"
              id="file-upload3"
              accept=".png, .jpg, .jpeg"
              name="payment_screenshot"
              onChange={handleChange}
            />
            <label htmlFor="file-upload3" id="file-drag">
              <img
                src={
                  form.payment_screenshot
                    ? URL.createObjectURL(form.payment_screenshot)
                    : ""
                }
                className="img-fluid22"
              />
              <div id="start">
                <div>Upload Image</div>
              </div>
            </label>
          </div>
          <p className="mt-0">*only jpeg, jpg & png files supported</p>
          {errors.payment_screenshot && (
            <div className="text-danger">{errors.payment_screenshot}</div>
          )}
        </div>

        {/* Transaction ID */}
        <div className="form-group">
          <label>UTR/TID:</label>
          <input
            type="text"
            className="form-control"
            placeholder="Utr number / Transaction number"
            name="utr"
            value={form.utr}
            onChange={handleChange}
          />
          {errors.utr && <span style={{ color: "red" }}>{errors.utr}</span>}
        </div>

        {/* Payment method (admin_account_id) */}
        {/* <div className="form-group">
          <label>Pay Via:</label>
          <div>
            <label>
              <input
                type="radio"
                name="admin_account_id"
                value={bankDetails?.id}
                checked={form.admin_account_id === bankDetails?.id}
                onChange={handleChange}
              />{" "}
              Bank
            </label>
            <label className="ml-3">
              <input
                type="radio"
                name="admin_account_id"
                value={upiDetails?.id}
                checked={form.admin_account_id === upiDetails?.id}
                onChange={handleChange}
              />{" "}
              UPI
            </label>
          </div>
          {errors.admin_account_id && (
            <span style={{ color: "red" }}>{errors.admin_account_id}</span>
          )}
        </div> */}

        {/* Bank Details */}
        <div className="min-max-amount">
          <div className="row">
            <div className="col-md-8">
              <div className="bank-detail bank-left">
                <h5>Bank Details</h5>
                <div className="bank-detail-outer border-right">
                  <p>Bank Name : {bankDetails?.config?.bank_name}</p>
                  <p>IFSC Code : {bankDetails?.config?.ifsc_code}</p>
                  <p>Account Number : {bankDetails?.config?.account_number}</p>
                  <p>Holder Name : {bankDetails?.config?.account_holder}</p>
                    <p>Branch Name: {bankDetails?.config?.branch_name}</p>
                      <p>Account Type : {bankDetails?.config?.account_type}</p>
                </div>
              </div>
            </div>
            {/* <div className="col-md-4">
              <div className="bank-detail bank-right-outer">
                <h5>Upi</h5>
                <p className="upi-id tc">{upiDetails?.config?.upi_id}</p>
                <div className="tc qr_man">
                  <QRCode
                    value={`upi://pay?pa=${
                      upiDetails?.config?.upi_id
                    }&pn=${encodeURIComponent(
                      upiDetails?.config?.account_holder || ""
                    )}`}
                  />
                </div>
              </div>
            </div> */}
          </div>
        </div>

        {/* Deposit Button */}
        <div className="deposit-amount-btn">
          <button className="btn btn_man fs14 m0a" onClick={handleDeposit}>
            Deposit Amount
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default INRDepositModel;
